import { render, staticRenderFns } from "./ProjectMappingRuleEdit.vue?vue&type=template&id=453c2b8b&"
import script from "./ProjectMappingRuleEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectMappingRuleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports